import { ReactElement, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Map from "./Map";
import Create from "./Create";
import Login from "./Login";
import PlaceDetail from "./components/PlaceDetail";
import LegalPage from "./Privacidad";
import EditPlace from "./Edit";
import EventoAltaPage from "./Eventos/EventoAltaPage";
import EventoList from "./Eventos/EventoList";
import EventoDetalle from "./Eventos/EventoDetalle";
import PlaceListWithSearch from "./components/PlaceListWithSearch";

const AppRouter = (): ReactElement => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Map />} />
        <Route path="/create" element={<Create />} />
        <Route path="/login" element={<Login />} />
        <Route path="/lugar/:slug/:id" element={<PlaceDetail />} />
        <Route path="/lugar/:id" element={<PlaceDetail />} />
        <Route path="/privacidad" element={<LegalPage />} />
        <Route path="/editar/:id" element={<EditPlace />} />
        <Route path="/evento/crear" element={<EventoAltaPage />} />
        <Route path="/eventos" element={<EventoList />} />
        <Route path="/lista" element={<PlaceListWithSearch />} />
        
      <Route path="/eventos/editar/:id" element={<EventoAltaPage />} />
      <Route path="/eventos/:id" element={<EventoDetalle />} />

      </Routes>
    </Suspense>
  );
};

export default AppRouter;